import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import { styled } from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Attention from "../../assets/icons/Attention.svg";

const MakePurchaseTooltip = ({ classes = "", brandName, brandId }) => {
  classes = classes + " search_pop";

  const HtmlTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} />
  ))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: "#FFFFFF",
      color: "rgba(0, 0, 0, 0.87)",
      width: theme.typography.pxToRem(130),
      height: theme.typography.pxToRem(49),
      fontSize: theme.typography.pxToRem(12),
      fontSize: 12,
      boxShadow: theme.shadows[2],
    },
  }));

  const AttentionTooltipComponent = React.forwardRef(
    function AttentionTooltipComponent(props, ref) {
      return <img src={Attention} {...props} ref={ref} />;
    },
  );

  return (
    <>
      <HtmlTooltip
        placement="top"
        title={
          <React.Fragment>
            <div>
              <label>Stock lower than</label>
              <br />
              <label>
                Min.&nbsp;
                <Link
                  to={{
                    pathname: `/add-purchasing-order`,
                    state: {
                      from: "ProductList_screen",
                      supplierName: "ABC Supplier",
                      supplierId: 123,
                    },
                  }}
                >
                  Make Purchase
                </Link>
              </label>
            </div>
          </React.Fragment>
        }
      >
        <AttentionTooltipComponent className={classes} />
      </HtmlTooltip>
    </>
  );
};

export default MakePurchaseTooltip;
